import React from 'react';
import { clsx } from 'clsx';
import type { ExpiryStatus } from '@/types/document';
import { CAC_DOC_STATUS_LABELS, type CacDocStatus } from '@/types/cac';
import { BADGE_CLASS, CAC_STATUS_TONES, EXPIRY_STATUS_LABELS, EXPIRY_STATUS_TONES, describeDaysToExpire } from '@/utils/expiry';
import { formatDateBR } from '@/utils/formatters';

/** Badge de validade de um Documento (`expiry_status`); nada quando não há validade. */
export const ExpiryBadge: React.FC<{ status: ExpiryStatus; days?: number | null; className?: string }> = ({
  status,
  days,
  className,
}) => {
  if (status === 'none') return null;
  const text = describeDaysToExpire(days);
  return (
    <span className={clsx(BADGE_CLASS[EXPIRY_STATUS_TONES[status]], className)} title={text || undefined}>
      {EXPIRY_STATUS_LABELS[status]}
    </span>
  );
};

/** Badge de status de um Documento CAC (`valid | expiring | expired | renewed`). */
export const CacStatusBadge: React.FC<{ status: CacDocStatus; className?: string }> = ({ status, className }) => (
  <span className={clsx(BADGE_CLASS[CAC_STATUS_TONES[status]], className)}>{CAC_DOC_STATUS_LABELS[status]}</span>
);

/** "dd/MM/aaaa · vence em N dias" com a cor do status. */
export const ExpiryLabel: React.FC<{ expiresAt?: string | null; days?: number | null; className?: string }> = ({
  expiresAt,
  days,
  className,
}) => {
  if (!expiresAt) return <span className={clsx('text-slate-400', className)}>sem validade</span>;
  const text = describeDaysToExpire(days);
  const tone =
    days === undefined || days === null ? 'text-slate-600' : days < 0 ? 'text-red-600' : days <= 30 ? 'text-amber-700' : 'text-slate-600';
  return (
    <span className={clsx('whitespace-nowrap', tone, className)}>
      {formatDateBR(expiresAt)}
      {text && <span className="text-slate-500"> · {text}</span>}
    </span>
  );
};
